export default "__VITE_ASSET__B7q8ZZMB__"